import { register } from '!/repository'
import { model as router } from '!/router'
import { createEvent, sample } from 'effector'
import * as pinLockFeature from '~/features/pin-lock'
import { model as session } from '~/entities/session'

export const init = createEvent()

const backToSettings = createEvent()

sample({
  clock: backToSettings,
  fn: () => '/modules/settings',
  target: router.navigatePush,
})

register(backToSettings, 'settings/content/backToSettings')

//
// Protect Content with PIN Lock
//

const setPinLock = createEvent<{ value: boolean }>()

sample({
  clock: setPinLock,
  source: session.$session,
  filter: (_, { value }) => value,
  fn: (session) => session?.accountNumber || '',
  target: pinLockFeature.enable,
})

sample({
  clock: setPinLock,
  source: session.$session,
  filter: (_, { value }) => !value,
  fn: (session) => session?.accountNumber || '',
  target: pinLockFeature.disable,
})

register(setPinLock, 'settings/content/pin-lock-set')
register(pinLockFeature.$enabled, '$settings/content/pin-lock-enabled')

//
// Tranlations
//
